import { EbenseeSoleleitung, Salzfabrik } from "../../Utils/GlbLoaderArtefakte.jsx";
import ExperienceModelViewer from "../ExperienceModelViewer.jsx";

export default function ArtefaktBundlesMuseumEbensee({ currentMuseumId }) {
  const { ebenseeSoleleitung } = EbenseeSoleleitung();
  const { salzfabrik } = Salzfabrik();

  const artefactArray = [ebenseeSoleleitung, salzfabrik];

  return <ExperienceModelViewer modelArray={artefactArray} currentMuseumId={currentMuseumId} />;
}
